// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabBodyItemActive":"tabBodyItemActive-H7rMJtKB","tabBodyItem":"tabBodyItem-qWI9m_Eb"};